<span class="pill-container" [ngClass]="type" [ngStyle]="{'min-width.px': minWidth}" [class.pill-full-width]="displayFullWidth">
  <span>{{text}}</span>
  <ng-content></ng-content>
</span>